import { render } from "./EditClientModal.vue?vue&type=template&id=52ae2733&ts=true"
import script from "./EditClientModal.vue?vue&type=script&lang=ts"
export * from "./EditClientModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__